import firedux from '../firedux'
import store, {dispatch} from '../store'

import setCurrentUserPresenceOnFirebase from '../setters/current_user_presence'
import setCurrentUserPresence from '../actions/set_current_user_presence'

import {PRESENCE, PRESENCE_ENDPOINT} from '../../config/constants'

export const watchCurrentUserPresence = (uid) => {
  const ENDPOINT = `${PRESENCE_ENDPOINT}/${uid}`

  // set to online after auth if he is offline
  firedux.ref.child(ENDPOINT).once('value', (snapshot) => {
    if (snapshot.val() === PRESENCE.OFFLINE) {
      firedux.ref.child(ENDPOINT).set(PRESENCE.ONLINE)
    }
  })

  firedux.ref.child(ENDPOINT).on('value', (snapshot) => {
    if (!snapshot.exists()) return

    const presence = snapshot.val()
    if (typeof(presence) === 'number' && presence !== PRESENCE.OFFLINE) {
      dispatch(setCurrentUserPresence(presence))
    }
    else if (presence === PRESENCE.OFFLINE) {
      setCurrentUserPresenceOnFirebase(PRESENCE.ONLINE)
    }
  })

  // firedux.ref.child(ENDPOINT).onDisconnect().set(PRESENCE.OFFLINE)
}

export const unwatchCurrentUserPresence = () => {
  const currentUser = store.getState().get('currentUser')

  if (currentUser && currentUser.get('uid')) {
    const ENDPOINT = `${PRESENCE_ENDPOINT}/${currentUser.get('uid')}`
    firedux.ref.child(ENDPOINT).set(PRESENCE.OFFLINE)
    firedux.ref.child(ENDPOINT).off()
    dispatch(setCurrentUserPresence(null))
  }
}



/** WEBPACK FOOTER **
 ** ./modules/shared/data/watchers/current_user_presence.js
 **/